<template>
  <div>
    <!-- Gps Access -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>GPS pristup lokaciji</a>
        </li>
      </ul>
    </div>

    <!-- Izaberi poligon -->
    <div>
      <div slot="content">
        <div>
          <div class="field">
            <label class="label no-print">Izaberi Poligon</label>
            <div class="control">
              <vue-select
                class="has-background-info-light"
                @option:selected="polygonSelected"
                type="text"
                label="name"
                :clearable="true"
                :options="polygons"
                v-model="selectedPolygon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- uredi poligone -->
    <div>
      <button class="button mt-2 mb-4">Uredi poligone...</button>
    </div>

    <!-- tabela GpsAccess događaja -->
    <div v-if="selectedPolygon" class="base-demo">
      <vue-table-dynamic :params="params" @cell-click="tableCellClicked">
      </vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import reportService from "../../services/report.service";

// const { DateTime } = require("luxon");

export default {
  name: "AccessGpsList",

  props: {
    today: Date,
    tomorrow: Date,
    vehicle: Object,
  },

  watch: {
    vehicle: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);

      this.resetUi();
      this.prepare();
    },
  },

  components: {},

  data() {
    return {
      polygons: [],
      polygonsFull: [],
      selectedPolygon: null,
      selectedPolygonFull: null,
      accessGpsList: [],
      params: {
        data: [
          [
            "Index",
            "Vrijeme unutra",
            "Vrijeme spolja",
            "Lokacija unutra",
            "Lokacija spolja",
            "Kilometar sat",
            "Stanje goriva",
            "Procenat goriva",
            "Događaj",
          ],
        ],
        header: "row",
        border: true,
        stripe: true,
        pagination: false,
      },
    };
  },

  mounted() {
    console.log("mounted");
    this.prepare();
  },

  methods: {
    async prepare() {
      this.polygonsFull = (await reportService.GetGpsPolygons()).data;

      this.polygons = [];
      this.polygonsFull.forEach((pf) => {
        this.polygons.push({
          id: pf.GpsPolygonId,
          name: pf.Name,
        });
      });
    },

    tableCellClicked(row, clmn) {
      console.log(row, clmn);
      let accessGps = this.accessGpsList.find(
        (ag) => ag.correspondingId == row
      );
      if (accessGps !== undefined) this.$emit("tableCellClcked", accessGps);
    },

    resetUi() {
      console.log("RESET");
      this.params.data = [
        [
          "Index",
          "Vrijeme unutra",
          "Vrijeme spolja",
          "Lokacija unutra",
          "Lokacija spolja",
          "Kilometar sat",
          "Stanje goriva",
          "Procenat goriva",
          "Događaj",
        ],
      ];

      this.selectedPolygon = null;
      this.selectedPolygonFull = null;
    },

    polygonSelected(polygon) {
      console.log("PL!");

      console.log(polygon);

      this.selectedPolygonFull = this.polygonsFull.find(
        (p) => p.GpsPolygonId === polygon.id
      );

      this.params.data = [
        [
          "Index",
          "Vrijeme unutra",
          "Vrijeme spolja",
          "Lokacija unutra",
          "Lokacija spolja",
          "Kilometar sat",
          "Stanje goriva",
          "Procenat goriva",
          "Događaj",
        ],
      ];

      reportService
        .GetAccessGpsByVehicleIdAndPolygonIdAndStartDateAndEndDate(
          this.vehicle.vehicleId,
          1,
          this.today,
          this.tomorrow
        )
        .then((rsp) => {
          let ndx = 0;
          this.accessGpsList = rsp.data;
          rsp.data.forEach((ga) => {
            console.log(ga);
            this.params.data.push([
              ++ndx,
              new Date(ga.insideTime).toLocaleTimeString("sr-latn-cs"),
              new Date(ga.outsideTime).toLocaleTimeString("sr-latn-cs"),
              ga.insideLatitude + ", " + ga.insideLongitude,
              ga.outsideLatitude + ", " + ga.outsideLongitude,
              ga.kilometers,
              ga.fuel,
              ga.fuelPercent,
              ga.enterArea ? "ušao" : "izašao",
            ]);
            ga.correspondingId = ndx;
            console.log(this.params.data);
          });
          // Sad poslati info o poligonu sa tačkama i rsp.data
          this.$emit("gpsDataLoaded", {
            polygon: this.selectedPolygonFull,
            accessGpsList: this.accessGpsList,
            vehicle: this.vehicle,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
